/*!
 * Mobix bundle coupons in the cart
 * Replaces the old inline watcher that sat after </html> in theme.liquid.
 * The old one listened for a 'cart:updated' event that Dawn never fires, so it only
 * ran on page load. This one listens to Dawn's own pub/sub cart event as well.
 *
 * Rules: product ID -> { quantity: coupon code }. The highest tier the cart quantity
 * reaches wins. These must match the discount codes that exist in Shopify admin.
 */
(function () {
  'use strict';

  var RULES = {
    8425726967987: { 2: 'dual-code', 3: 'triple-code' },            /* Mobix DualView Pro */
    8430922596531: { 2: 'dual-code-pods', 3: 'triple-code-pods' },  /* Mobix SmartPods Pro */
    8564543488179: { 2: 'AQUA-150', 3: 'AQUA-300' },                /* AquaJet */
    8499683164339: { 2: 'breeze-dual', 3: 'breeze-triple' },        /* Mobix Tactical Breeze */
    8767053365427: { 2: 'cleaner50', 3: 'cleaner100' },             /* Mobix GrillPro */
    8767053496499: { 2: 'sc100', 3: 'sc250' },                      /* Mobix Home Cleaner */
    8767053824179: { 2: 'dreams100', 3: 'dreams200' }               /* Mobix Sweet Dreams */
  };
  var KEY = 'mx_cart_code';
  var busy = false;

  function remember(v) { try { if (v) sessionStorage.setItem(KEY, v); else sessionStorage.removeItem(KEY); } catch (e) {} }
  function recall() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }

  function pick(cart) {
    var qty = {};
    (cart.items || []).forEach(function (it) { qty[it.product_id] = (qty[it.product_id] || 0) + it.quantity; });
    var best = null;
    Object.keys(RULES).forEach(function (pid) {
      var q = qty[pid] || 0;
      if (q < 2) return;
      var tiers = Object.keys(RULES[pid]).map(Number).sort(function (a, b) { return b - a; });
      for (var i = 0; i < tiers.length; i++) {
        if (q >= tiers[i]) {
          if (!best || tiers[i] > best.tier) best = { code: RULES[pid][tiers[i]], tier: tiers[i] };
          break;
        }
      }
    });
    return best ? best.code : null;
  }

  function onCartPage() { return /^\/cart\/?$/.test(location.pathname); }

  function sync() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var code = pick(cart);
        var applied = (cart.cart_level_discount_applications || []).concat(
          (cart.items || []).reduce(function (a, it) { return a.concat(it.line_level_discount_allocations || []); }, [])
        ).some(function (x) {
          var t = (x.title || (x.discount_application && x.discount_application.title) || '').toLowerCase();
          return code && t === code.toLowerCase();
        });
        if (!code || applied || recall() === code) return null;
        return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' }).then(function () {
          remember(code);
          /* the cart page shows totals rendered by the server: refresh once so the discount appears */
          if (onCartPage()) location.reload();
        });
      })
      .catch(function (e) { if (window.console) console.warn('Mobix coupons:', e); })
      .then(function () { busy = false; });
  }

  function hook() {
    /* Dawn declares these as top-level bindings (const / function), not window properties */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { remember(null); sync(); });
    }
    document.addEventListener('cart:updated', function () { remember(null); sync(); });
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook);
  else hook();
})();